export default function Arrow() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.70031 16.5605C2.11452 17.1463 1.16477 17.1463 0.578988 16.5605C-0.00679838 15.9748 -0.00679801 15.025 0.578989 14.4392L2.70031 16.5605ZM15.1396 0.499972C15.968 0.499972 16.6396 1.17155 16.6396 1.99997L16.6396 15.5C16.6396 16.3284 15.968 17 15.1396 17C14.3111 17 13.6396 16.3284 13.6396 15.5L13.6396 3.49997L1.63956 3.49997C0.811137 3.49997 0.139565 2.82839 0.139565 1.99997C0.139565 1.17154 0.811138 0.499966 1.63957 0.499967L15.1396 0.499972ZM0.578989 14.4392L14.0789 0.939311L16.2002 3.06063L2.70031 16.5605L0.578989 14.4392Z"
        fill="black"
      />
    </svg>
  );
}
